import React, { useEffect, useState } from "react";
import useApi from "../../hook/useApi";
import Loader from "../../components/Loader/Loader";
import { CURRENCY_CODE, REFUND_STATUS } from "../../utils/constant";

const ViewEsimBookingLayer = ({ id }) => {
  const { AsyncGetApiCall } = useApi();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getBooking = async () => {
      if (!id) return;
      setLoading(true);
      const result = await AsyncGetApiCall(`/esim/admin/order-details/${id}`);
      if (result?.success) {
        setBooking(result.data);
      }
      setLoading(false);
    };

    getBooking();
  }, [id]);

  if (loading) return <Loader />;
  if (!booking) return <p className="text-center my-5">No data found.</p>;

  const esim = booking?.eSimBookings?.[0] || {};
  const txData = booking?.txData || {};
  const user = booking?.userId || {};
  const paidCurrency = txData?.paidCurrency || esim?.currency || "";
  const originalCurrency = txData?.originalCurrency || esim?.currency || "";
  const paidAmount =
    txData?.paidAmount ??
    txData?.originalAmount ??
    esim?.net_price ??
    esim?.price ??
    0;
  const originalAmount =
    txData?.originalAmount ??
    txData?.paidAmount ??
    esim?.price ??
    esim?.net_price ??
    0;

  return (
    <div className="row gy-4">
      <div className="col-12">
        <div className="card p-24 radius-12">
          <h5 className="text-md fw-semibold mb-24">User Information</h5>
          <div className="row gy-3">
            <div className="col-md-6"><label className="form-label">User Id</label><p className="text-secondary-light">{user?._id || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Email</label><p className="text-secondary-light">{user?.email || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Wallet Address</label><p className="text-secondary-light">{user?.walletAddress || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Created Date</label><p className="text-secondary-light">{user?.createdAt ? new Date(user.createdAt).toLocaleString("en-IN") : "N/A"}</p></div>
          </div>
        </div>
      </div>

      <div className="col-12">
        <div className="card p-24 radius-12">
          <h5 className="text-md fw-semibold mb-24">eSIM Booking Details</h5>
          <div className="row gy-3">
            <div className="col-md-6"><label className="form-label">Order Id</label><p className="text-secondary-light">{booking?.orderId || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Package</label><p className="text-secondary-light">{esim?.package_id || esim?.code || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Network</label><p className="text-secondary-light">{esim?.network || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Country</label><p className="text-secondary-light">{esim?.country || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Data</label><p className="text-secondary-light">{esim?.data || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Validity</label><p className="text-secondary-light">{esim?.validity || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Status</label><p className="text-secondary-light">{esim?.status || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Refund Status</label><p className="text-secondary-light">{REFUND_STATUS[booking?.refundStatus] || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Created At</label><p className="text-secondary-light">{booking?.createdAt ? new Date(booking.createdAt).toLocaleString("en-IN") : "N/A"}</p></div>
          </div>
        </div>
      </div>

      <div className="col-12">
        <div className="card p-24 radius-12">
          <h5 className="text-md fw-semibold mb-24">Payment Details</h5>
          <div className="row gy-3">
            <div className="col-md-6"><label className="form-label">Original Amount</label><p className="text-secondary-light">{`${CURRENCY_CODE[paidCurrency] || paidCurrency} ${Number(paidAmount || 0).toFixed(2)}`}</p></div>
            <div className="col-md-6"><label className="form-label">Paid Amount</label><p className="text-secondary-light">{`${CURRENCY_CODE[originalCurrency] || originalCurrency} ${Number(originalAmount || 0).toFixed(2)}`}</p></div>
            <div className="col-md-6"><label className="form-label">Payment Method</label><p className="text-secondary-light">{txData?.paymentMethod || "N/A"}</p></div>
            <div className="col-md-6"><label className="form-label">Paid Currency</label><p className="text-secondary-light">{paidCurrency || "N/A"}</p></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewEsimBookingLayer;
